import notification from "antd/es/notification";
import { defineMessages } from "react-intl";
import { put, select } from "redux-saga/effects";

import Organization from "@mapmycustomers/shared/types/Organization";

import i18nService from "@app/config/I18nService";
import { callApi } from "@app/store/api/callApi";
import { getOrganizationId } from "@app/store/iam";

import { hideDuplicates, hideLeads, showHiddenLeads } from "../actions";

const messages = defineMessages({
  hideLeadDescription: {
    id: "leadFinder.store.notifications.leads.hide.successs.description",
    defaultMessage: "You will no longer see this result unless hidden results are toggled on.",
    description: "Lead hidden success description",
  },
  hideLeadSuccessTitle: {
    id: "leadFinder.store.notifications.leads.hide.successs.title",
    defaultMessage: "Result hidden successfully",
    description: "Lead hidden success title",
  },
  showLeadDescription: {
    id: "leadFinder.store.notifications.leads.show.success.description",
    defaultMessage: "You will always see this result in Lead Finder.",
    description: "Lead shown success description",
  },
  showLeadSuccessTitle: {
    id: "leadFinder.store.notifications.leads.show.success.title",
    defaultMessage: "Result shown successfully",
    description: "Lead shown success title",
  },
});

export function* onHideLeads({ payload }: ReturnType<typeof hideLeads.request>) {
  const orgId: Organization["id"] = yield select(getOrganizationId);
  try {
    yield callApi("updateHiddenLeads", orgId, payload.placeIds);
    yield put(hideDuplicates());
    yield put(hideLeads.success({ placeIds: payload.placeIds }));
    notification.success({
      description: i18nService.formatMessage(messages.hideLeadDescription),
      message: i18nService.formatMessage(messages.hideLeadSuccessTitle),
    });
  } catch {
    yield put(hideLeads.failure());
  }
}

export function* onShowHiddenLeads({ payload }: ReturnType<typeof showHiddenLeads.request>) {
  const orgId: Organization["id"] = yield select(getOrganizationId);
  try {
    yield callApi("deleteHiddenLeads", orgId, payload.placeIds);
    yield put(hideDuplicates());
    yield put(showHiddenLeads.success({ placeIds: payload.placeIds }));
    notification.success({
      description: i18nService.formatMessage(messages.showLeadDescription),
      message: i18nService.formatMessage(messages.showLeadSuccessTitle),
    });
  } catch {
    yield put(showHiddenLeads.failure());
  }
}
